/**
 * ErrorScreen - エラー画面コンポーネント
 */

interface ErrorScreenProps {
  error: string
}

export function ErrorScreen({ error }: ErrorScreenProps) {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-red-500 text-white p-4 rounded-lg max-w-md">
        <h2 className="text-lg font-bold mb-2">エラー</h2>
        <p>{error}</p>
      </div>
    </div>
  )
}